import { render, staticRenderFns } from "./courseGroupDetail.vue?vue&type=template&id=a3071c02&scoped=true&"
import script from "./courseGroupDetail.vue?vue&type=script&lang=js&"
export * from "./courseGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./courseGroupDetail.vue?vue&type=style&index=0&id=a3071c02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3071c02",
  null
  
)

export default component.exports